module.exports = __webpack_public_path__ + "img/4-5.68f904f6.png";